import { ActionTree } from 'vuex';

export default <ActionTree<example.state.ExampleState, RootState>>{
};
